import { getData, postData, deleteRequest } from './api';
import { ActivityFeedResponse } from '../types/activity';

interface HideContactResponse {
  success: boolean;
  hiddenContact: {
    contactId: string;
    contactName: string;
  };
}

interface IsContactHiddenResponse {
  isHidden: boolean;
}

export const activityApi = {
  getRecentActivity: (
    limit: number = 20,
    offset: number = 0
  ): Promise<ActivityFeedResponse> => getData<ActivityFeedResponse>('/api/activity', {
    params: { limit, offset },
  }),

  hideContact: async (contactId: string): Promise<HideContactResponse['hiddenContact']> => {
    return (await postData<HideContactResponse>(`/api/activity/hide-contact/${contactId}`)).hiddenContact;
  },

  unhideContact: (contactId: string): Promise<void> =>
    deleteRequest(`/api/activity/hide-contact/${contactId}`),

  isContactHidden: async (contactId: string): Promise<boolean> => {
    return (await getData<IsContactHiddenResponse>(`/api/activity/hide-contact/${contactId}`)).isHidden;
  },
};

export default activityApi;
